import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { SearchTagsState } from '../models/search-filters.model';
import * as selectors from '../selectors/search-tags.selectors';

@Injectable({ providedIn: 'root' })
export class SearchTagsFacadeService extends FacadeService {
  constructor(public override store: Store<SearchTagsState>) {
    super(store);
  }

  panelExpanded$ = this.storeSelect(selectors.getPanelExpansion);
  tagType$ = this.storeSelect(selectors.getTagType);
  tagTypeSelectionValues$ = this.storeSelect(
    selectors.getTagTypeSelectionValues
  );
  tagCode$ = this.storeSelect(selectors.getTagCode);
  tagLabel$ = this.storeSelect(selectors.getTagLabel);
  searchRole$ = this.storeSelect(selectors.getSearchRole);
  searchButtonDisabled$ = this.storeSelect(selectors.getSearchButtonDisabled);
  createNewButtonDisabled$ = this.storeSelect(
    selectors.getCreateNewButtonDisabled
  );

  get panelExpanded() {
    return this.storeSnapshot(this.panelExpanded$);
  }

  get tagType() {
    return this.storeSnapshot(this.tagType$);
  }

  get tagCode() {
    return this.storeSnapshot(this.tagCode$);
  }

  get tagLabel() {
    return this.storeSnapshot(this.tagLabel$);
  }

  get tagTypeSelectionValues() {
    return this.storeSnapshot(this.tagTypeSelectionValues$);
  }
}
